import script from "./themeBuilder.vue?vue&type=script&setup=true&lang=js"
export * from "./themeBuilder.vue?vue&type=script&setup=true&lang=js"

import "./themeBuilder.vue?vue&type=style&index=0&id=12298f70&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12298f70"]])

export default __exports__